import * as bus from "@sinch/bus";
const TIMEOUT = 4000;

function parseURL(request: RequestInfo | URL): URL | Error {
  try {
    if (typeof request === "string") {
      return new URL(request);
    } else if (request instanceof Request) {
      return new URL(request.url);
    } else {
      return TypeError("Invalid request type");
    }
  } catch (err) {
    return new Error("Invalid request url ");
  }
}

export function patchFetchWithBus() {
  const { fetch: originalFetch } = window;

  window.fetch = async function fetchWithBus(
    ...args: Parameters<typeof window.fetch>
  ): ReturnType<typeof window.fetch> {
    const [request, options] = args;

    const url = parseURL(request);
    if (!(url instanceof URL)) {
      return originalFetch(...args);
    }

    if (url.protocol !== "bus:") {
      return originalFetch(...args);
    }

    let requestClone: Request;
    if (request instanceof Request) {
      requestClone = request.clone();
    } else {
      requestClone = new Request(request, options);
    }

    const requestBody = requestClone?.body
      ? await new Response(requestClone.body).json().catch(console.error)
      : undefined;

    return new Promise((resolve, reject) => {
      const requestId = crypto.randomUUID();
      const serviceKey = url.host + url.pathname;

      const busRequest = bus.createRPCRequestMessage(
        requestId,
        serviceKey,
        requestBody
      );

      bus.sendLocal(busRequest);

      const unsubListenResponse = bus.listen(
        (message: bus.RPCResponseMessage) => {
          if (!bus.isData(message)) {
            return;
          }
          if (message.payload.requestId === requestId) {
            const res = new Response(JSON.stringify(message.payload.body));
            resolve(res);
            unsubListenResponse();
          }
        },
        bus.isRPCResponseMessage
      );

      const unsubListenReady = bus.listen((message: bus.RPCReadyMessage) => {
        if (!bus.isData(message)) {
          return;
        }
        if (message.payload.serviceKey === serviceKey) {
          bus.sendLocal(busRequest);
        }
      }, bus.isRPCReadyMessage);

      setTimeout(() => {
        unsubListenReady();
        unsubListenResponse();
        reject("timeout");
      }, TIMEOUT);
    });
  };

  return () => {
    window.fetch = originalFetch;
  };
}
